import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from "@angular/core";
import { AppMainComponent } from "src/app/app.main.component";
import * as _ from "lodash";
import { CONTACT_ASSOCIATION_ID } from "src/app/modules/shared/constants/typeId";

@Component({
    selector: "app-contact-selection-modal",
    templateUrl: "./contact-selection-modal.component.html",
    styleUrls: ["./contact-selection-modal.component.scss"],
})
export class ContactSelectionModalComponent implements OnChanges {
    
    @Input() displayContactSelectionModal;
    @Input() contacts;
    @Input() selectedContact;
    @Input() accountInfo;
    
    @Output() onContactSelectionComplete = new EventEmitter();
    @Output() onAddContact = new EventEmitter();
    @Output() cancel = new EventEmitter();
    
    contactAssociationId = CONTACT_ASSOCIATION_ID.ACCOUNT;

    constructor(public app: AppMainComponent) {}

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.contacts && changes.contacts.currentValue) {
            this.contacts = changes.contacts.currentValue;
            if (this.contacts && this.contacts.length > 0) {
                this.contacts.forEach((element) => {
                    element.id = element.contactId;
                });
            }
        }
    }
    onRowSelectContact(e) {
        this.onContactSelectionComplete.emit(this.selectedContact);
    }
    addContact(e) {
        this.onAddContact.emit(e);
    }
    onDialogClose() {
        this.cancel.emit(false);
    }
}
    
